import {
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  Renderer2,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  TemplateRef,
  ViewContainerRef,
  OnDestroy,
  ChangeDetectorRef,
} from "@angular/core";
import { Location } from "@angular/common";
import { HeaderData } from "../../models/header-items";
import { ShareDataService } from "../../../shared/services/shared.service";
import { Router } from "@angular/router";
import { InputType } from "../input/input-type";
import { AlertType } from "../alert/alert-type";
import { CommonModalComponent } from "../common.modal/common.modal.component";
import { ButtonType } from "../button/button-type";
import { ButtonPurpose } from "../button/button-purpose";
import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { TemplatePortal } from "@angular/cdk/portal";
import { TranslateService } from "../../services/translate";
import { TitleValidationService } from "../../services/title-validation.service";
import { take } from "rxjs";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    standalone: false
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
  public headerName: String;
  public isBack: boolean;
  public title: String;
  public renameTitle: boolean;
  public totalPoints: number;
  public totalQuestions: number;
  public previewButton: String;
  private collectionId: Number;
  public inputType = InputType;
  showQuestionTypes: boolean = false;
  public editorLoaderStaticMessage: string =
    "Please wait... Question editor is opening on new tab.";
  public editorLoaderMessage: string = this.editorLoaderStaticMessage;
  menuWidth: any;
  itemInfoData: any;
  public buttonType = ButtonType;
  public _buttonPurpose = ButtonPurpose;
  public stepperAnnouncementMessage: string = '';
  private sourceSelectionAnnouncementMessage: string = '';
  private settingsAnnouncementMessage: string = '';

  headerData: HeaderData;

  constructor(
    private shareDataService: ShareDataService,
    private router: Router,
    private _location: Location,
    private renderer: Renderer2,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private cdr: ChangeDetectorRef,
    private translateService: TranslateService,
    private titleValidationService: TitleValidationService,
  ) {}

  public show = false;
  public buttonName: any = "Show";
  public alertMessageData: String = "";
  public showHeaderPreferences = true;
  public showConfirmationHeader = false;
  public alertMessage: String =
    "You have not saved your changes. Are you sure you want to continue?";
  public modalHeader: String = "Confirmation";
  public size: any = { width: 500 };
  public showRenameError: boolean = false;
  public RenameErrorMsg: String = "";
  public alertType = AlertType;
  public overlayRef: OverlayRef;
  @Input("operationMode") operationMode: String;
  @Input("subRoute") subRoute: String;
  @Input() alertSuccessMessage: String;
  @Input() showSuccessAlert: boolean = false;
  @Input("showQuestionTypeBtn") showQuestionTypeBtn: boolean;
  @Input() inputPlaceholder: string;
  @Input() suppressAnnouncement: boolean = false;
  @Output() itemInfoDataEmitter = new EventEmitter<any>();
  @Output() focusCreateQuestion = new EventEmitter<any>();
  @Output() closeAlert = new EventEmitter<void>();

  @Input()
  set collection_id(collection_id: Number) {
    this.collectionId = collection_id;
  }
  @Output() settingsRouteActivate = new EventEmitter<any>();
  @Output() filterEvent = new EventEmitter<boolean>();
  @ViewChild('editorShowModal') editorShowModal!: ElementRef<HTMLElement>;
  @ViewChild('editorAlertTemplatePortal', { static: true })
  editorAlertTemplatePortal: TemplateRef<any>;

  ngOnInit() {
    // Load translations
    this.translateService.translate('ngx-shared-page-changed-1')
      .pipe(take(1))
      .subscribe(msg => this.sourceSelectionAnnouncementMessage = msg);

    this.translateService.translate('ngx-shared-page-changed-2')
      .pipe(take(1))
      .subscribe(msg => this.settingsAnnouncementMessage = msg);

    this.headerData = this.shareDataService.getHeaderData();
    if (this.headerData == null) {
      this.shareDataService.getCollection().subscribe((data) => {
        this.headerData = data;
      });
      if (this.headerData == null) {
        this.headerData = new HeaderData();
      }
    }
    this.headerName = this.headerData.getTitle();
    this.isBack = this.headerData.getIsBack();
    this.title = this.headerName;
    this.totalPoints = this.headerData.getTotalPoints();
    this.totalQuestions = this.headerData.getTotalQuestion();
    this.previewButton = this.headerData.getPreviewButton();

    this.shareDataService.getFocusOnTitle().subscribe((data) => {
      this.showHideTitle(true);
    });
    this.createEditorAlertModalOverlay();
    this.shareDataService.getOpenEditorModalValue().subscribe((message) => {
      if (message === true) {
        this.editorLoaderMessage = this.editorLoaderStaticMessage;
      }
      setTimeout(() => {
        this.editorLoaderMessage =
          "You have opened question editor on a new tab. Please close or exit the editor tab to hide this popup.";
      }, 5000);

      if (message) {
        this.showEditorAlertModal();
      }
      else {
        this.closeEditorAlertModal();
      }
    });
  }
  ngOnDestroy() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['subRoute']) {
      this.stepperAnnouncement();
    }
  }

  modelChanged(event) {
    /** Share data on title change*/
    this.headerData.setTitle(event);
    this.shareDataService.setHeaderData(this.headerData);
    this.shareDataService.setCollection(this.headerData);

    const validationResult = this.titleValidationService.validateTitle(event);
    if (!validationResult.isValid) {
      this.showErrors(validationResult.message);
    } else {
      this.hideErrors();
    }
  }

  _keyUp(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);
  }

  private createEditorAlertModalOverlay() {
    let positionStrategy = this.overlay.position().global().centerHorizontally().centerVertically();

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.block(),
      disposeOnNavigation: true
    });
  }

  showEditorAlertModal() {
    this.closeEditorAlertModal(false);
    if (this.editorAlertTemplatePortal && this.overlayRef && !this.overlayRef.hasAttached()) {
      const templatePortal = new TemplatePortal(this.editorAlertTemplatePortal, this.viewContainerRef);
      this.overlayRef.attach(templatePortal);

      const element = document.querySelector('app-root');
      element.setAttribute('inert', '');
      element.setAttribute('aria-hidden', 'true');
      this.cdr.detectChanges();
      this.editorShowModal?.nativeElement.focus();
    }
  }

  closeEditorAlertModal(focusPreviousElement: boolean = true) {
    if (this.overlayRef && this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
    if (focusPreviousElement) {
      const element = document.querySelector('app-root');
      element.removeAttribute('inert');
      element.removeAttribute('aria-hidden');
      this.focusCreateQuestion.emit();
    }
  }

  cancel(event: Event) {
    event.preventDefault();
    if (this.operationMode === "sourceSelect") {
      if (this.subRoute != "step2") {
        const message = {
          Message: this.alertMessage,
        };
        this.shareDataService.sendConfirmMessageData(message);
      } else {
        if (this.shareDataService.getCategoryFilterCount()) {
          this.shareDataService.getCategoryFilterCount().length = 0;
        }
        if (this.subRoute == "step2") {
          this.shareDataService.setCurrentStep("step1");
          this.shareDataService.setLandingState("my-state");
          this.filterEvent.emit(false);
          this.router.navigate(["/sourceSelect"]);
        } else {
          if (
            this.shareDataService &&
            this.shareDataService.getLandingState() === "edit-state"
          ) {
            this.router.navigate(["/editAssessment", "edit"]);
          } else {
            this.router.navigate(["/list"]);
          }
        }
      }
    } else if (
      this.operationMode === "create" ||
      this.headerName == "Unnamed Test" ||
      this.subRoute == "step2"
    ) {
      if (
        this.operationMode == "create" ||
        this.headerName == "Unnamed Test" ||
        (this.headerData && this.headerData.getTitle() == "Unnamed Test")
      ) {
        const message = {
          Message: this.alertMessage,
        };
        this.shareDataService.sendConfirmMessageData(message);
      } else {
        this.showConfirmationHeader = true;
      }
    } else if (this.operationMode === "edit") {
      if (this.shareDataService.getCategoryFilterCount()) {
        this.shareDataService.getCategoryFilterCount().length = 0;
      }
      this.router.navigate(["/list"]);
    } else {
      if (this.shareDataService.getCategoryFilterCount()) {
        this.shareDataService.getCategoryFilterCount().length = 0;
      }
      this._location.back();
    }
  }

  public editNewAssessment() {
    this.headerData.setCollectionId(this.headerData.getCollectionId());
    this.headerData.setTitle(this.headerData.getTitle());
    this.shareDataService.setHeaderData(this.headerData);
    this.router.navigate(["/editAssessment", "edit"]);
  }

  public modalOkJob() {
    if (this.subRoute == "step2") {
      this.settingsRouteActivate.emit("step1");
    } else {
      this._location.back();
    }
    this.showConfirmationHeader = false;
  }

  public modalCancelJob() {
    this.showConfirmationHeader = false;
  }
  public showErrors(msg) {
    this.showRenameError = true;
    this.RenameErrorMsg = msg;
  }

  public hideErrors() {
    this.showRenameError = false;
    this.RenameErrorMsg = "";
  }

  public showHideTitle(showHide: boolean) {
    this.show = showHide;
    var elemRender = this.renderer;
    if (this.show) {
      this.setFocus(elemRender);
    }
  }

  private setFocus(elemRender: Renderer2) {
    setTimeout(function () {
      const element = elemRender.selectRootElement("#testTitle");
      element.focus();
    }, 100);
  }

  updateChangeValueOfDropdown(value) {
    this.showQuestionTypes = value;
  }

  passValueToSource(val) {
    this.itemInfoData = val;
    this.itemInfoDataEmitter.emit(this.itemInfoData);
  }
  closeAlertModal() {
    this.closeAlert.emit();
  }

  stepperAnnouncement() {
    if (this.subRoute === null || this.subRoute === undefined) return;

    switch(this.subRoute) {
      case 'step1':
        this.stepperAnnouncementMessage = this.sourceSelectionAnnouncementMessage;
        break;
      case 'step2':
        this.stepperAnnouncementMessage = this.settingsAnnouncementMessage;
        break;
      default:
        this.stepperAnnouncementMessage = `You're currently on ${this.subRoute}`;
    }
  }
}
